/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Title/view.blocks to change it.
import Indicator from './Indicator/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Title({
  children,
  viewPath = "/DesignSystem/TimelineEvent/Order/Content/Title"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="Title.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<Indicator
  viewPath={`${viewPath}/Indicator`}
/>
</div>
{children}
</React.Fragment>)
}